import React, { useEffect } from "react";
import { useParams, Navigate, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isSupportedLocale, isRTL } from "@/i18n";

export const LocaleProvider: React.FC = () => {
  const { locale } = useParams<{ locale: string }>();
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (locale && isSupportedLocale(locale) && i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
    if (locale && isSupportedLocale(locale)) {
      document.documentElement.lang = locale;
      document.documentElement.dir = isRTL(locale) ? "rtl" : "ltr";
    }
  }, [locale, i18n]);

  useEffect(() => {
    return () => {
      // Reset direction when unmounted (e.g. navigating to /)
      document.documentElement.dir = "ltr";
    };
  }, []);

  if (!locale || !isSupportedLocale(locale)) {
    // Legacy un-prefixed paths (e.g. /code-of-conduct, /news/slug) → /en/...
    const legacy = location.pathname.replace(/\/+$/, "");
    const target = legacy.startsWith("/use-cases") ? "/en/pricing" : `/en${legacy}`;
    return <Navigate to={`${target}${location.search}${location.hash}`} replace />;
  }

  return <Outlet />;
};
